<template>
	<div>
		<div class="fab" uk-toggle='target: #offcanvas-overlay' @click="toggleFab">
			{{ fabText }}
		</div>
		<div id="offcanvas-overlay" uk-offcanvas="overlay: true">
				<div class="uk-offcanvas-bar"  style="width: 500px">
						<button class="uk-offcanvas-close" type="button" uk-close></button>
						
						<h4>Quick links</h4>
						<div class="uk-grid">
							<div class="uk-width-1-2" v-show="cpEditUrl">	
								<a :href="cpEditUrl" target="_blank">
									<button class="uk-button uk-button-primary uk-button-small uk-width-1-1">Artikel 	bewerken</button>
								</a>
							</div>
							<div class="uk-width-1-2" v-if="articleUrl">	
								<clipboard :text="articleUrl" button-text="Kopiëer link"></clipboard>
							</div>
							<div class="uk-width-1-2  uk-margin-small-top" v-show="bitlyApiKey">	
								<bitly-generator :long-url="articleUrl" :api-key="bitlyApiKey"></bitly-generator>
							</div>						
							<div v-show="articleAppUrl" class="uk-width-1-2  uk-margin-small-top">	
								<a :href="articleAppUrl" target="_blank">
									<button class="uk-button uk-button-secondary uk-button-small uk-width-1-1">App artikel</button>
								</a>
							</div>
							<div class="uk-width-1-2  uk-margin-small-top">	
								<clipboard :text="articleUrl"  :open-link="true" link="https://search.google.com/u/2/search-console/inspect?resource_id=sc-domain%3Anieuwnieuws.nl" button-text="Google Console"></clipboard>
							</div>	
							<div v-show="showCardsGenerator" class="uk-width-1-2  uk-margin-small-top">	
									<button uk-toggle="target: #cards-generator-modal" class="uk-button uk-button-secondary uk-button-small uk-width-1-1">Card generator</button>
							</div>						
						</div>
						
						<div v-show="facebookPages" class="uk-margin-top">
							<h4>Facebook suite</h4>
							<div class="uk-grid uk-grid-small">
								<div v-for="(url, name) in facebookPages" :key="name" :href="url" class="uk-width-1-2">	
									<a :href="url" target="_blank">
										<button class="uk-button uk-button-primary uk-button-small facebook uk-width-1-1">{{ name }}</button>
									</a>
								</div>
							</div>
						</div>
						
						<h4>Cards</h4>
						<div class="uk-grid uk-grid-small">
							
							<div class="uk-width-1-2">	
										
								<strong>Story</strong>	
								<card-generator 
									:id="entryId"
									:platform-type="cardsPlatformType"
									:generated-card="generatedStoryCard"
									:templates="storyCardTemplates"
									:title="entryTitle"
									:caption="entryCaption"
									:image-url="socialCard"
									button-text="Genereren"
									:download-to-server="true" 
									cards-url="{{ cardsUrl }}"
									:template-format-names="['default']"
								>
								</card-generator>
								
							</div>
							<div class="uk-width-1-2">

								<strong>Default</strong>
								<card-generator 
									:id="entryId"
									:platform-type="cardsPlatformType"
									:generated-card="generatedSocialCard"
									:templates="socialCardTemplates"
									:title="entryTitle"
									:category="entryCategory"
									:caption="entryCaption"
									:image-url="socialCard"
									button-text="Genereren"
									:download-to-server="true" 
									cards-url="{{ cardsUrl }}"
									:template-format-names="['default','link_in_comments']"
								>
								</card-generator>		

							</div>
	
							<div class="uk-width-1-2 uk-margin-top">

								<strong>Slide 1/2</strong>
								<card-generator 
									:id="entryId"
									:platform-type="cardsPlatformType"
									:generated-card="generatedInstagramSlide1Card"
									:templates="instagramSlide1Templates"
									:title="entryTitle"
									:category="entryCategory"
									:caption="entryCaption"
									:image-url="socialCard"
									button-text="Genereren"
									:download-to-server="true" 
									cards-url="{{ cardsUrl }}"
								>
								</card-generator>		
							
							</div>

							<div class="uk-width-1-2 uk-margin-top">

								<strong>Slide 2/2</strong>

								<card-generator 
									:id="entryId"
									:platform-type="cardsPlatformType"
									:generated-card="generatedInstagramSlide2Card"
									:templates="instagramSlide2Templates"
									:title="entryTitle"
									:category="entryCategory"
									:caption="entryCaption"
									:description="entryDescription"
									:image-url="entryImage"
									button-text="Genereren"
									:download-to-server="true" 
									cards-url="{{ cardsUrl }}"
								>
								</card-generator>	
							
							</div>
							
						</div>
						
				</div>
		</div>
	</div>
</template>

<script>
import Clipboard from './Clipboard.vue'
import CardGenerator from './CardGenerator.vue'

export default {
	components: { Clipboard, CardGenerator },
  props: {
		entryId: {
			type: Number,
		},
		entryTitle: {
			type: String,
		},
		entryCategory: {
			type: String,
		},		
		entryCaption: {
			type: String,
		},		
		entryDescription: {
			type: String,
		},	
		entryImage: {
			type: String,
		},
		cpEditUrl: {
			type: String,
			required: false
		},
		baseCpUrl: {
			type: String,
		},
		contentUrl: {
			type: String,	
		},
		cardsUrl: {
			type: String,	
		},
		cardsPlatformType: {
			type: String,
			required: true
		},
		socialCardTemplates: {
			type: Array,
		},			
		storyCardTemplates: {
			type: Array,
		},
		instagramSlide1Templates: {
			type: Array,
		},	
		instagramSlide2Templates: {
			type: Array,
		},				
		socialCard: {
			type: String,
		},
		generatedSocialCard: {
			type: String,
			required: false
		},
		generatedStoryCard: {
			type: String,
			required: false
		},		
		generatedInstagramSlide1Card: {
			type: String,
			required: false			
		},
		generatedInstagramSlide2Card: {
			type: String,
			required: false			
		},		
		articleUrl: {
			type: String,
			required: false
		},
		facebookScheduledUrl: {
			type: String,
			required: false
		},
		showCardsGenerator: {
			type: Boolean,
			default: false
		}
  },
	data() {
		return {
			status: 'closed',
			fabText: '+',
			defaultImage: 'https://placehold.co/200x300?text=no card found',
		}
	},
	mounted() {
		this.$logger('app/components/admin-panel/mounted');
	},
  computed: {
	},
  methods: {
		noImageFound(e) {
			this.$logger('app/components/admin-panel/setDefaultCard');
			e.target.src = this.defaultImage;
		},			
		toggleFab() {
			var component = this;
			component.status = (component.status == 'closed') ? 'open' : 'closed';
		},
		noImageFound(e) {
			this.$logger('app/components/admin-panel/setDefaultCard');
			e.target.src = this.defaultImage;
		},
		generateStoryCard() {
			alert('wordt aan gewerkt')
		}
  }
}
</script>

<style scoped>
.fab {
		z-index: 2000;
		width: 60px;
		height: 60px;
		background-color: var(--tint-color);
		border-radius: 50%;
		box-shadow: 0 6px 10px 0 #666;
		transition: all 0.1s ease-in-out;

		font-size: 24px;
		color: white;
		text-align: center;
		line-height: 60px;

		position: fixed;
		right: 25px;
		bottom: 80px;
		
		cursor: pointer;
}

.fab:hover {
		box-shadow: 0 6px 14px 0 #666;
		transform: scale(1.05);
}
</style>